import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAction } from '../utils/react-redux'
import { fitAddresses } from '../../store/map/map.actions'
import { isGE } from '../Device'
import { selectAddresses } from '../../store/address/address.selectors'
import { selectIsMapFullScreen } from '../../store/map/map.selectors'

export const AddressFullscreenMapHandler = () => {
  const isMapFullscreen = useSelector(selectIsMapFullScreen)
  const addresses = useSelector(selectAddresses)
  const execFitAddresses = useAction(fitAddresses)

  useEffect(() => {
    if (isGE()) return
    execFitAddresses(addresses)
  }, [isMapFullscreen])

  return <></>
}

export default AddressFullscreenMapHandler
